import styled from 'styled-components'

export const ScreenContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 50px 50px 50px;
	${({ $alignItems }) => $alignItems && `align-items: ${$alignItems};`}
	${({ $justifyContent }) => $justifyContent && `justify-content: ${$justifyContent};`}
	${({ $textAlign }) => $textAlign && `text-align: ${$textAlign};`}
	${({ $gap }) => $gap && `gap: ${$gap};`}
	${({ $fullHeight }) =>
		$fullHeight &&
		`
		height: 100%;
		min-height: 100vh;
	`}
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		overflow-y: auto;
		${({ $mobileAlignItems }) => $mobileAlignItems && `align-items: ${$mobileAlignItems};`}
		${({ $mobilePadding }) => $mobilePadding && `padding: ${$mobilePadding};`}
	}
`

export const FixedBottomButtonContainer = styled.div`
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		padding: 16px;
		background-color: ${props => props.theme.colors.brand.white};
		box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
	}
`

export const BackButton = styled.button`
	background: none;
	border: none;
	color: ${props => props.theme.colors.brand.blueOmint};
	font-weight: 600;
	font-size: 16px;
	display: flex;
	align-items: center;
	padding: 0;
	${({ $gap }) => $gap && `gap: ${$gap};`}
	${({ $marginBottom }) => $marginBottom && `margin-bottom: ${$marginBottom};`}

	& > svg {
		margin-left: -6px;
	}

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		position: fixed;
		top: 0;
		left: 0;
		height: 56px;
		padding-left: 16px;
		z-index: 2;
		${({ $mobileMarginBottom }) => $mobileMarginBottom && `margin-bottom: ${$mobileMarginBottom};`}
	}
`
